/*
 * This file is part of Mitei Server.
 * Copyright (c) 2019 f0reachARR <f0reach@f0reach.me>
 *
 * Mitei Server is free software: you can redistribute it and/or modify
 * it under the terms of the GNU General Public License as published by
 * the Free Software Foundation, version 3 of the License.
 *
 * Mitei Server is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with Mitei Server.  If not, see <http://www.gnu.org/licenses/>.
 */
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import * as React from 'react';
const confirmDialogContext = React.createContext({
    isOpen: false,
    title: null,
    content: null,
    open: () => { },
    close: () => { },
});
export const ConfirmDialogContextProvider = ({ children }) => {
    const [open, setOpen] = React.useState(false);
    const [content, setContent] = React.useState(null);
    const [title, setTitle] = React.useState(null);
    const callbackRef = React.useRef(() => { });
    const contextValue = {
        isOpen: open,
        open: (title, content, callback) => {
            setTitle(title);
            setContent(content);
            callbackRef.current = callback;
            setOpen(true);
        },
        close: result => {
            callbackRef.current(result);
            setOpen(false);
        },
        content,
        title,
    };
    return (React.createElement(confirmDialogContext.Provider, { value: contextValue }, children));
};
export const useConfirmDialog = () => {
    const contextValue = React.useContext(confirmDialogContext);
    return (title, content) => {
        return new Promise(resolve => {
            contextValue.open(title, content, val => resolve(val));
        });
    };
};
export const ConfirmDialogView = () => {
    const contextValue = React.useContext(confirmDialogContext);
    const handleOK = () => {
        contextValue.close(true);
    };
    const handleClose = () => {
        contextValue.close(false);
    };
    return (React.createElement(Dialog, { open: contextValue.isOpen, onClose: handleClose, fullWidth: true },
        React.createElement(DialogTitle, null, contextValue.title),
        React.createElement(DialogContent, null, contextValue.content),
        React.createElement(DialogActions, null,
            React.createElement(Button, { color: 'primary', onClick: handleClose }, "\u30AD\u30E3\u30F3\u30BB\u30EB"),
            React.createElement(Button, { color: 'primary', onClick: handleOK }, "OK"))));
};
//# sourceMappingURL=index.js.map